import {
  ChallengeResultSchema,
  type ChallengeResult,
  type SubmitChallenge,
} from "shared"
import { parseApiError } from "@rawa/api-client/ApiResponseError"

// Answers either with the invitation the participant is identified for, or with
// a request for their surname. A 4xx is the uniform refusal.
export async function postChallenge(
  body: SubmitChallenge,
): Promise<ChallengeResult> {
  const res = await fetch("/api/challenge", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  })
  if (!res.ok) throw await parseApiError(res)
  return ChallengeResultSchema.parse(await res.json())
}
